import type { ResponsiveType } from './types'

export const twRounded: ResponsiveType = {
  sm: 'ds-rounded-sm',
  md: 'ds-rounded-md',
  lg: 'ds-rounded-lg'
}
